import type { IconComponentProps } from "..";

export function PlayStationIcon(props: IconComponentProps) {
	return (
		<svg
			{...props}
			fill="currentColor"
			role="img"
			viewBox="1 1 198 152.82"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>PlayStation</title>
			<path d="m197.24 117.96c-3.8677 4.8796-13.344 8.3605-13.344 8.3605l-70.491 25.32v-18.673l51.877-18.484c5.887-2.1092 6.791-5.091 2.0058-6.656-4.7762-1.5696-13.425-1.1198-19.316 0.99841l-34.566 12.174v-19.379l1.9923-0.6746s9.9886-3.5349 24.034-5.091c14.045-1.5471 31.243 0.21137 44.744 5.3293 15.214 4.8076 16.928 11.895 13.065 16.775zm-77.125-31.796v-47.753c0-5.6082-1.0344-10.771-6.2963-12.233-4.0296-1.2907-6.5301 2.451-6.5301 8.0547v119.58l-32.25-10.236v-142.58c13.712 2.5455 33.689 8.5629 44.429 12.183 27.312 9.3769 36.572 21.047 36.572 47.343 0 25.63-15.822 35.344-35.925 25.639zm-104.25 44.852c-15.619-4.3984-18.219-13.564-11.099-18.844 6.5796-4.8751 17.769-8.5449 17.769-8.5449l46.241-16.442v18.745l-33.276 11.909c-5.878 2.1092-6.782 5.0955-2.0058 6.6605 4.7807 1.5651 13.434 1.1198 19.321-0.99391l15.961-5.7926v16.771c-1.0119 0.17989-2.1407 0.35978-3.1841 0.53518-15.966 2.6084-32.97 1.5201-49.727-4.0026z" fillRule="evenodd" />
		</svg>
	);
}
